import React from 'react'
import styles from './AdminCommunities.module.scss'
import AppSelect from 'elements/appSelect'
import ContentDataSelector from 'containers/Workflows/ContentDataSelector/ContentDataSelector'
import { GroupService } from 'api/services/groups'
import { toast } from 'react-toastify'
import { setlocalStorageValue } from 'utils/localStorage'
import { useHistory } from 'react-router';

const AdminCommunities = ({ isAuthed }: { isAuthed: any }) => {

    const hideDropdownRef = React.useRef<any>(null);
    const [groups, setGroups] = React.useState<any>(null);
    const [searchString, setSearchString] = React.useState<any>('');
    const [selectedGroup, setSelectedGroup] = React.useState<any>(null);
    const history = useHistory();

    const continueInstallation = (selectedGroupID: number) => {
        if (isAuthed) {
            const getQueryParams = (): URLSearchParams => new URLSearchParams(window.location.search);
            const searchParams: any = getQueryParams();
            let params: any = {}
            for (let [key, value] of searchParams.entries()) {
                params[key] = value;
            }
            if (Object.keys(params).length > 0) {
                GroupService.getInstance()
                    .intergrationAuthorization(selectedGroupID, params.app_id, {
                        redirect: params.redirect
                    })
                    .then((response: any) => {
                        if (response) {
                            window.open(response.authorization_url, "_self");
                        }
                    })
                    .catch((error: any) => {
                        toast(" Please try again later.", {
                            type: 'error',
                            autoClose: 3000,
                            position: "top-center",
                            hideProgressBar: true,
                            theme: "light"
                        });
                        console.error(error)
                    })
                    .finally(() => { })
            }
        }
    }

    React.useEffect(() => {
        if (isAuthed) {
            GroupService.getInstance()
                .getUserAdminCommunities()
                .then((response: any) => {
                    if (response) {
                        const newList = response.data.filter((grp: any) => grp !== null).map((item: any) => {
                            return {
                                label: item.name,
                                value: item.name,
                                id: item.id,
                            }
                        });
                        setGroups(newList);
                    }
                })
                .catch((error: any) => {
                    toast(" Please try again later.", {
                        type: 'error',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                    console.error(error)
                })
                .finally(() => { })
        } else {
            // setTimeout(() => {
                let url = new URL(window.location.href)
                let pathandQuery = url.pathname + url.search;
                setlocalStorageValue("next_link", pathandQuery)
                history.push('/login')
            // }, 1000);
        }



    }, [isAuthed, window.location.pathname])


    const filteredData = (searchString && searchString.trim() !== "")
        ? groups && groups.filter((item: any) =>
            item.label.toLowerCase().includes(searchString.toLowerCase())
        )
        : groups


    return (
        <div className={styles.AdminCommunities}>
            <div className={styles.AdminCommunities__container}>
                <div className={styles.AdminCommunities__container__header}>
                    <h1 className={styles.AdminCommunities__container__header__h1}>Kit(Convertkit) Installation</h1>
                    <p className={styles.AdminCommunities__container__header__p}>Select your community to continue installation</p>
                </div>
                <AppSelect
                    popupStyles={{ minHeight: '100px' }}
                    inputClassName={styles.inputActionTrigger}
                    disabled={selectedGroup}
                    XIconstyles={selectedGroup ? styles.XIconstyles : ""}
                    placeholder="Search or select a community"
                    hideDropdownRef={hideDropdownRef}
                    value={
                        searchString &&
                            searchString.trim() !== ''
                            ?
                            searchString
                            :
                            selectedGroup ?
                                (selectedGroup.label.charAt(0).toUpperCase() + selectedGroup.label.slice(1))
                                :
                                ''
                    }
                    markRequired
                    cursorPointer
                    inputIconClassName={`${styles.inputIconNameAction} ${selectedGroup ? styles.inputIconNameActionNone : ""} ${selectedGroup ? styles.hideXIconstyles : ""}`}
                    onChangeValue={(e: any) => setSearchString(e.target.value)}
                    onRemoveSelectedValue={() => {
                        setSearchString('');
                        setSelectedGroup(null);
                    }}
                >
                    {
                        filteredData !== null ?
                            <div className={styles.ActiontypesDropdown}>
                                <ContentDataSelector
                                    data={filteredData}
                                    onDataSelected={(value: any, data: any) => {
                                        setSearchString('');
                                        hideDropdownRef.current();
                                        // continueInstallation(data.id);
                                        setSelectedGroup({
                                            id: data.id,
                                            ...data
                                        });
                                    }}
                                    labelStyle={styles.eventResourceTypelabelStyle}
                                    elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                />
                            </div>
                            :
                            <></>
                    }
                </AppSelect>
                <div className={styles.AdminCommunities__container__footer}>
                    <button
                        disabled={!selectedGroup}
                        onClick={() => {
                            if (selectedGroup) {
                                continueInstallation(selectedGroup.id);
                            }
                        }}
                        className={`${styles.AdminCommunities__container__footer__button} ${selectedGroup === null ? styles.AdminCommunities__container__footer__disabled : '' }`}>
                        Continue
                    </button>
                </div>
            </div>

        </div>
    )
}

export default AdminCommunities